export default __webpack_public_path__ + "6e66ffe6ae2df55ed09065e5f2bb1d54.glb";